(function($) {
	'use strict';
	$.fn.Slide__RemoveFromCollection = function() {
		this.each(function() { 

			/*
			 * Action: Add slide to collection
			 */
			var $self = $(this),
				collection_id = $self.data('cid'),
				slide_id = $self.data('sid');
				
			
			// Listen for click
			$self.off( $.Globals.clickEvent ).on( $.Globals.clickEvent, function(e) {
				e.preventDefault();
				
				
				// Add confirm
				var confirmed = confirm( Front.translations.confirm_remove_slide );

				if( confirmed ) {

					// Remove slide to this collection
					$.Globals.addRemoveSlideFromCollection( collection_id, slide_id );
					
					// Remove from grid-list
					$('.grid-container .component-slide-list-item[data-sid="' + slide_id + '"], .grid-container .component-slide-grid-item[data-sid="' + slide_id + '"]').remove();
					
					// Close controller edit overlay
					$.Globals.closeOverlay();
					

				}
				
			});
			
		
		});
		return this;
	};
}(jQuery));